import Mock from "mockjs"; // 引入mockjs

Mock.mock("/api/screen/getPlaceOfOrigin?type=1", "get", {
  resultCode: 200,
  resultMessage: "查询成功",
  list: [{
      name: "浙江",
      value: 0
    },
    {
      name: "海南",
      value: 0
    },
    {
      name: "四川",
      value: 0
    },
    {
      name: "山西",
      value: 0
    },
    {
      name: "上海",
      value: 0
    },
    {
      name: "江苏",
      value: 0
    },
    {
      name: "内蒙",
      value: 0
    },
    {
      name: "上海",
      value: 0
    },
    {
      name: "浙江",
      value: 0
    },
    {
      name: "新疆",
      value: 0
    },
    {
      name: "安徽",
      value: 0
    },
    {
      name: "山西",
      value: 0
    },
    {
      name: "黑龙江",
      value: 0
    },
    {
      name: "辽宁",
      value: 0
    },
  ],
});

Mock.mock("/api/screen/getTradingVolume?type=1", "get", {
  resultCode: 200,
  resultMessage: "查询成功",
  data: [{
      result: 0,
      time: "01",
      id: "000000879",
    },
    {
      result: 0,
      time: "02",
      id: "000000879",
    },
    {
      result: 0,
      time: "03",
      id: "000000879",
    },
    {
      result: 1,
      time: "04",
      id: "000000879",
    },
    {
      result: 0,
      time: "05",
      id: "000000879",
    },
    {
      result: 0,
      time: "06",
      id: "000000879",
    },
    {
      result: 0,
      time: "07",
      id: "000000879",
    },
    {
      result: 0,
      time: "08",
      id: "000000879",
    },
    {
      result: 0,
      time: "09",
      id: "000000879",
    },
    {
      result: 0,
      time: "10",
      id: "000000879",
    },
    {
      result: 0,
      time: "11",
      id: "000000879",
    },
    {
      result: 0,
      time: "12",
      id: "000000879",
    },
    {
      result: 74,
      time: "01",
      id: "000000878",
    },
    {
      result: 152,
      time: "02",
      id: "000000878",
    },
    {
      result: 0,
      time: "03",
      id: "000000878",
    },
    {
      result: 2,
      time: "04",
      id: "000000878",
    },
    {
      result: 0,
      time: "05",
      id: "000000878",
    },
    {
      result: 0,
      time: "06",
      id: "000000878",
    },
    {
      result: 0,
      time: "07",
      id: "000000878",
    },
    {
      result: 0,
      time: "08",
      id: "000000878",
    },
    {
      result: 0,
      time: "09",
      id: "000000878",
    },
    {
      result: 0,
      time: "10",
      id: "000000878",
    },
    {
      result: 0,
      time: "11",
      id: "000000878",
    },
    {
      result: 0,
      time: "12",
      id: "000000878",
    },
    {
      result: 26,
      time: "01",
      id: "000000882",
    },
    {
      result: 0,
      time: "02",
      id: "000000882",
    },
    {
      result: 0,
      time: "03",
      id: "000000882",
    },
    {
      result: 1,
      time: "04",
      id: "000000882",
    },
    {
      result: 0,
      time: "05",
      id: "000000882",
    },
    {
      result: 0,
      time: "06",
      id: "000000882",
    },
    {
      result: 0,
      time: "07",
      id: "000000882",
    },
    {
      result: 0,
      time: "08",
      id: "000000882",
    },
    {
      result: 0,
      time: "09",
      id: "000000882",
    },
    {
      result: 0,
      time: "10",
      id: "000000882",
    },
    {
      result: 0,
      time: "11",
      id: "000000882",
    },
    {
      result: 0,
      time: "12",
      id: "000000882",
    },
    {
      result: 0,
      time: "01",
      id: "000000880",
    },
    {
      result: 2,
      time: "02",
      id: "000000880",
    },
    {
      result: 0,
      time: "03",
      id: "000000880",
    },
    {
      result: 0,
      time: "04",
      id: "000000880",
    },
    {
      result: 0,
      time: "05",
      id: "000000880",
    },
    {
      result: 0,
      time: "06",
      id: "000000880",
    },
    {
      result: 0,
      time: "07",
      id: "000000880",
    },
    {
      result: 0,
      time: "08",
      id: "000000880",
    },
    {
      result: 0,
      time: "09",
      id: "000000880",
    },
    {
      result: 0,
      time: "10",
      id: "000000880",
    },
    {
      result: 0,
      time: "11",
      id: "000000880",
    },
    {
      result: 0,
      time: "12",
      id: "000000880",
    },
  ],
  list: [{
      result: 1,
      goodsname: "蔬菜",
      id: "000000879",
    },
    {
      result: 228,
      goodsname: "绿香蕉",
      id: "000000878",
    },
    {
      result: 27,
      goodsname: "柑橘",
      id: "000000882",
    },
    {
      result: 2,
      goodsname: "青菜",
      id: "000000880",
    },
  ],
});
// 市场进出货量
Mock.mock("/api/screen2/getCarsCargoVolume?type=1", "get", {
  "resultCode": 200,
  "resultMessage": "查询成功",
  "inList": [{
    "weight": 2363.00,
    "time": "01"
  }, {
    "weight": 0,
    "time": "02"
  }, {
    "weight": 5950.00,
    "time": "03"
  }, {
    "weight": 24378.00,
    "time": "04"
  }, {
    "weight": 0,
    "time": "05"
  }, {
    "weight": 0,
    "time": "06"
  }, {
    "weight": 0,
    "time": "07"
  }, {
    "weight": 0,
    "time": "08"
  }, {
    "weight": 0,
    "time": "09"
  }, {
    "weight": 0,
    "time": "10"
  }, {
    "weight": 0,
    "time": "11"
  }, {
    "weight": 0,
    "time": "12"
  }],
  "outList": [{
    "weight": 100,
    "time": "01"
  }, {
    "weight": 154.0000000000000000,
    "time": "02"
  }, {
    "weight": 0,
    "time": "03"
  }, {
    "weight": 694.10000000000000000000,
    "time": "04"
  }, {
    "weight": 0,
    "time": "05"
  }, {
    "weight": 0,
    "time": "06"
  }, {
    "weight": 0,
    "time": "07"
  }, {
    "weight": 0,
    "time": "08"
  }, {
    "weight": 0,
    "time": "09"
  }, {
    "weight": 0,
    "time": "10"
  }, {
    "weight": 0,
    "time": "11"
  }, {
    "weight": 0,
    "time": "12"
  }]
});
// 车辆进出量
Mock.mock("/api/screen/getVehicleStatistics?type=1", "get", {
  "resultCode": 200,
  "resultMessage": "查询成功",
  "inList": [{
    "result": 3,
    "time": "01"
  }, {
    "result": 0,
    "time": "02"
  }, {
    "result": 14,
    "time": "03"
  }, {
    "result": 21,
    "time": "04"
  }, {
    "result": 0,
    "time": "05"
  }, {
    "result": 0,
    "time": "06"
  }, {
    "result": 0,
    "time": "07"
  }, {
    "result": 0,
    "time": "08"
  }, {
    "result": 0,
    "time": "09"
  }, {
    "result": 0,
    "time": "10"
  }, {
    "result": 0,
    "time": "11"
  }, {
    "result": 0,
    "time": "12"
  }],
  "outList": [{
    "result": 2,
    "time": "01"
  }, {
    "result": 0,
    "time": "02"
  }, {
    "result": 2,
    "time": "03"
  }, {
    "result": 7,
    "time": "04"
  }, {
    "result": 0,
    "time": "05"
  }, {
    "result": 0,
    "time": "06"
  }, {
    "result": 0,
    "time": "07"
  }, {
    "result": 0,
    "time": "08"
  }, {
    "result": 0,
    "time": "09"
  }, {
    "result": 0,
    "time": "10"
  }, {
    "result": 0,
    "time": "11"
  }, {
    "result": 0,
    "time": "12"
  }]
})
// 市场交易金额
Mock.mock("/api/screen/getTransactionAmount?type=1", "get", {
  "resultCode": 200,
  "resultMessage": "查询成功",
  "list": [{
    "total_amount": "0.0712",
    "time": "01"
  }, {
    "total_amount": "0.2167",
    "time": "02"
  }, {
    "total_amount": "",
    "time": "03"
  }, {
    "total_amount": "0.2680",
    "time": "04"
  }, {
    "total_amount": "",
    "time": "05"
  }, {
    "total_amount": "",
    "time": "06"
  }, {
    "total_amount": "",
    "time": "07"
  }, {
    "total_amount": "",
    "time": "08"
  }, {
    "total_amount": "",
    "time": "09"
  }, {
    "total_amount": "",
    "time": "10"
  }, {
    "total_amount": "",
    "time": "11"
  }, {
    "total_amount": "",
    "time": "12"
  }]
});
// 市场单品进出量
Mock.mock("/api/screen/getGoodsCargoVolume?type=1", "get", {
  "resultCode": 200,
  "resultMessage": "查询成功",
  "inList": [{
    "goods_name": "水果",
    "goods_id": "000000881",
    "weight": 10.00
  }, {
    "goods_name": "红富士",
    "goods_id": "000000837",
    "weight": 100.00
  }, {
    "goods_name": "绿石榴",
    "goods_id": "000000871",
    "weight": 698.00
  }, {
    "goods_name": "苹果",
    "goods_id": "000000836",
    "weight": 750.00
  }, {
    "goods_name": "苹果梨",
    "goods_id": "000000839",
    "weight": 1158.00
  }, {
    "goods_name": "柑橘",
    "goods_id": "000000882",
    "weight": 1300.00
  }, {
    "goods_name": "红石榴",
    "goods_id": "000000870",
    "weight": 1816.00
  }, {
    "goods_name": "苹果测试",
    "goods_id": "000000841",
    "weight": 2020.00
  }],
  "outList": [{
    "category_id": "000000870",
    "weight": 4.90
  }, {
    "category_id": "000000836",
    "weight": 2.30
  }, {
    "category_id": "000000882",
    "weight": 289.50
  }]
});